type OnboardingProgressProps = {
  currentStep: number;
  totalSteps: number;
};

export function OnboardingProgress({
  currentStep,
  totalSteps,
}: OnboardingProgressProps) {
  const progress = Math.min(currentStep / totalSteps, 1);

  return (
    <div className='px-6 pt-2 pb-4'>
      <div className='h-1 bg-black/[0.06] rounded-full overflow-hidden'>
        <div
          className='h-full bg-primary rounded-full transition-all duration-300'
          style={{ width: `${progress * 100}%` }}
        />
      </div>
    </div>
  );
}
